import { render } from "./CustomersList.vue?vue&type=template&id=3dfa391d&scoped=true"
import script from "./CustomersList.vue?vue&type=script&lang=js"
export * from "./CustomersList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3dfa391d"

export default script